import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <p>We are based in London and open for projects worldwide.</p>
      <Contact/>
    </div>
  </Layout>
)